import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { LOYALTY_LANDING_PAGE } from 'loyalty/constants/loyaltyRoutes'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import React from 'react'
import Table from 'LuxKit/Tables/Table'
import TableHeader from 'LuxKit/Tables/TableHeader'
import TableHeaderCell from 'LuxKit/Tables/TableHeaderCell'
import TableHeaderRow from 'LuxKit/Tables/TableHeaderRow'
import TableBody from 'LuxKit/Tables/TableBody'
import TableBodyCell from 'LuxKit/Tables/TableBodyCell'
import TableBodyRow from 'LuxKit/Tables/TableBodyRow'

function LoyaltyGenericInfoModal() {
  const programDisplayName = getLoyaltyProgramDisplayName()

  return <Modal
    title="Earning points, status credits & nights"
    subtitle={<>As a member of {programDisplayName}, you can earn points, status credits and nights on eligible bookings.</>}
    secondaryActionText="Find out more"
    secondaryActionTo={`/${LOYALTY_LANDING_PAGE}`}
    secondaryActionTarget="_blank"
  >
    <Group direction="vertical" gap={16}>
      <BodyText variant="medium" weight="bold">{getLoyaltyProgramDisplayName()} Points</BodyText>
      <BodyText variant="medium">
        Earn and redeem points on hotels, tours, flights, cruises and more.
      </BodyText>

      <BodyText variant="medium" weight="bold">{getLoyaltyProgramDisplayName()} Status Credits & Nights</BodyText>
      <BodyText variant="medium">
        Collect status credits and nights to move up tiers and unlock rewards including room upgrades, airport transfers, lounge passes and more.
      </BodyText>

      <Table>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCell>Tier</TableHeaderCell>
            <TableHeaderCell>Status Credits</TableHeaderCell>
            <TableHeaderCell>Nights</TableHeaderCell>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          <TableBodyRow>
            <TableBodyCell>Silver</TableBodyCell>
            <TableBodyCell>200</TableBodyCell>
            <TableBodyCell>10</TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>Gold</TableBodyCell>
            <TableBodyCell>600</TableBodyCell>
            <TableBodyCell>20</TableBodyCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableBodyCell>Platinum</TableBodyCell>
            <TableBodyCell>1000</TableBodyCell>
            <TableBodyCell>30</TableBodyCell>
          </TableBodyRow>
        </TableBody>
      </Table>
    </Group>
  </Modal>
}

export default LoyaltyGenericInfoModal
